// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expenses-page {
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font: 400 13px/1.4 var(--font-family-primary, "Lexend", sans-serif);
}
.expenses-page button,
.expenses-page input {
  font: inherit;
}
.expenses-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}
.expenses-hero h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.48px;
}
.expenses-hero p,
.expenses-period,
.expenses-filters > p,
.expenses-disclaimer {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.expenses-hero__actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.expenses-button {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.expenses-button--primary {
  border-color: var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.expenses-button:not(.expenses-button--primary):hover {
  border-color: var(--border-strong, #8b9996);
}
.expenses-button--primary:hover {
  border-color: var(--interactive-hover, #0a655f);
  background: var(--interactive-hover, #0a655f);
}
.expenses-period {
  margin-top: 26px;
}
.expenses-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-top: 26px;
}
.expenses-summary article {
  min-height: 154px;
  padding: 24px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
}
.expenses-summary h2 {
  margin: 0 0 24px;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
}
.expenses-summary strong {
  display: block;
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 22px;
  line-height: 27px;
}
.expenses-summary p {
  margin: 8px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}
.expenses-tabs {
  display: flex;
  margin-top: 26px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expenses-tabs button {
  padding: 10px 16px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-primary, #142624);
  cursor: pointer;
  transition: color 0.15s ease;
}
.expenses-tabs button:hover {
  color: var(--text-secondary, #506360);
  background: transparent;
  box-shadow: none;
}
.expenses-tabs button.is-active {
  border-bottom-color: var(--interactive-default, #0f766e);
  color: var(--interactive-default, #0f766e);
}
.expenses-filters {
  display: grid;
  grid-template-columns: minmax(0, 320px) minmax(0, 1fr);
  align-items: center;
  column-gap: 12px;
  row-gap: 10px;
  padding: 12px 0 24px;
}
.expenses-search {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
}
.expenses-search > svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: var(--text-secondary, #506360);
}
.expenses-search input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-primary, #142624);
  font-size: 13px;
}
.expenses-search:hover {
  border-color: var(--border-strong, #8b9996);
}
.expenses-search:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.expenses-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.expenses-filter {
  flex: 0 1 auto;
  width: max-content;
  max-width: 100%;
}
.expenses-filter-row .quotation-figma-dropdown-trigger {
  height: auto;
  min-height: 44px;
  padding: var(--space-3, 12px);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font: 500 13px/18px var(--font-family-primary, "Lexend", sans-serif);
}
.expenses-filter-row .quotation-figma-dropdown-trigger > span {
  white-space: normal;
  overflow-wrap: anywhere;
}
.expenses-filter-row .quotation-figma-dropdown-trigger:hover {
  border-color: var(--border-strong, #8b9996);
}
.expenses-filter-row .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger,
.expenses-filter-row .quotation-figma-dropdown-trigger:focus-visible {
  padding: 11px;
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.expenses-filter-row .quotation-figma-dropdown-menu {
  max-height: 224px;
  overflow-y: auto;
  scrollbar-width: thin;
}
.expenses-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.expenses-clear:hover {
  background: var(--surface-secondary, #f4f7f7);
  border-color: var(--border-default, #cdd6d4);
}
.expenses-filters > p {
  grid-column: 1 / -1;
  margin-top: 0;
}
.expenses-register {
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  overflow: visible;
}
.expenses-register__heading,
.expenses-pagination {
  min-height: 50px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}
.expenses-register__heading span,
.expenses-pagination {
  color: var(--text-secondary, #506360);
}
.expenses-table-wrap {
  overflow-x: auto;
}
.expenses-register table {
  border-collapse: collapse;
  width: 100%;
  min-width: 1120px;
}
.expenses-register th,
.expenses-register td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  font-size: 13px;
}
.expenses-register th {
  height: 64px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font-weight: 500;
}
.expenses-register td {
  height: 76px;
}
.expenses-money {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
}
.expenses-status {
  display: inline-flex;
  padding: 3px 7px;
  border-radius: 999px;
  font-size: 12px;
}
.expenses-status.is-attached {
  background: var(--surface-tertiary, #e8edec);
  color: var(--text-secondary, #506360);
}
.expenses-status.is-missing {
  background: var(--warning-soft, #fef8ec);
  color: var(--warning-text, #7d4412);
}
.expenses-receipt-state {
  display: inline-grid;
  justify-items: start;
  gap: 4px;
}
.expenses-receipt-state button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #0f766e);
  font: 500 12px/16px var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.expenses-receipt-state button:hover {
  color: var(--interactive-hover, #0a655f);
  text-decoration: underline;
}
.expenses-actions-cell {
  position: relative;
}
.expenses-actions-cell > button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.expenses-menu {
  position: absolute;
  right: 16px;
  top: 52px;
  z-index: 5;
  min-width: 112px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 8px 24px rgba(14, 26, 32, 0.12);
}
.expenses-menu button {
  width: 100%;
  padding: 8px;
  border: 0;
  border-radius: 6px;
  text-align: left;
  background: transparent;
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.expenses-menu button:hover {
  background: var(--interactive-soft, #f0f8f7);
}
.expenses-empty {
  padding: 40px;
  text-align: center;
  color: var(--text-secondary, #506360);
}
.expenses-pagination > div {
  display: flex;
  gap: 8px;
}
.expenses-pagination button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.expenses-pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.expenses-disclaimer {
  margin-top: 22px;
}
/* Match quotation and invoice register typography without changing layout. */
.expenses-hero h1 {
  font-weight: 600;
}
.expenses-hero p {
  font-size: 14px;
  line-height: 22px;
}
.expenses-page .expenses-button,
.expenses-page .expenses-tabs button,
.expenses-page .expenses-clear {
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
}
.expenses-search input {
  font-size: 14px;
  line-height: 20px;
}
.expenses-summary strong {
  font-size: 24px;
  line-height: 29px;
}
.expenses-register__heading strong {
  font-weight: 500;
}
.expenses-register td {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.expenses-register td.expenses-money {
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
}
.expenses-status {
  font-size: 11px;
  font-weight: 500;
  line-height: 14.3px;
  letter-spacing: 0.11px;
}
.expenses-page .expenses-menu button {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.expenses-pagination {
  font-size: 12px;
  line-height: 17px;
}
@media (max-width: 900px) {
  .expenses-summary {
    grid-template-columns: 1fr;
  }
  .expenses-summary article {
    min-height: auto;
  }
}
@media (max-width: 600px) {
  .expenses-filters {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 12px;
  }
  .expenses-hero {
    display: block;
  }
  .expenses-hero h1 {
    font-size: 28px;
  }
  .expenses-hero__actions {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .expenses-button--primary {
    grid-column: 1/-1;
    justify-content: center;
  }
  .expenses-summary {
    gap: 12px;
    margin-top: 20px;
  }
  .expenses-tabs {
    overflow-x: auto;
  }
  .expenses-tabs button {
    white-space: nowrap;
  }
  .expenses-filter-row {
    display: grid;
    grid-template-columns: 1fr;
  }
  .expenses-filter {
    width: 100%;
  }
  .expenses-clear {
    justify-self: start;
  }
  .expenses-register {
    border-radius: 10px;
  }
  .expenses-register__heading span {
    display: none;
  }
  .expenses-table-wrap {
    overflow: visible;
  }
  .expenses-register table {
    min-width: 0;
  }
  .expenses-register thead {
    display: none;
  }
  .expenses-register tbody,
  .expenses-register tr,
  .expenses-register td {
    display: block;
  }
  .expenses-register tr {
    position: relative;
    padding: 16px;
    border-bottom: 1px solid var(--border-subtle, #dce3e2);
  }
  .expenses-register td {
    height: auto;
    min-height: 34px;
    padding: 6px 44px 6px 112px;
    border: 0;
  }
  .expenses-register td::before {
    content: attr(data-label);
    position: absolute;
    left: 16px;
    color: var(--text-secondary, #506360);
  }
  .expenses-register .expenses-actions-cell {
    position: absolute;
    right: 8px;
    top: 8px;
    padding: 0;
  }
  .expenses-register .expenses-actions-cell::before {
    display: none;
  }
  .expenses-menu {
    right: 0;
    top: 34px;
  }
  .expenses-pagination {
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
  }
  .expenses-pagination span {
    max-width: 190px;
  }
}
.expenses-loading-row td {
  height: 76px;
}
.expenses-loading-row .app-skeleton {
  margin-block: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Expenses/expenses.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,mEAAmE;AACrE;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;;;EAIE,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iEAAiE;EACjE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wDAAwD;EACxD,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,oEAAoE;AACtE;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2CAA2C;AAC7C;AACA;;EAEE,aAAa;EACb,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;EACtD,eAAe;AACjB;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,iEAAiE;EACjE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,qCAAqC;AACvC;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,QAAQ;AACV;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,oEAAoE;EACpE,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA,6EAA6E;AAC7E;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qCAAqC;IACrC,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;;;IAGE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,sDAAsD;EACxD;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;EACX;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,QAAQ;IACR,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".expenses-page {\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font: 400 13px/1.4 var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expenses-page button,\n.expenses-page input {\n  font: inherit;\n}\n.expenses-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n.expenses-hero h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n.expenses-hero p,\n.expenses-period,\n.expenses-filters > p,\n.expenses-disclaimer {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.expenses-hero__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n.expenses-button {\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.expenses-button--primary {\n  border-color: var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.expenses-button:not(.expenses-button--primary):hover {\n  border-color: var(--border-strong, #8b9996);\n}\n.expenses-button--primary:hover {\n  border-color: var(--interactive-hover, #0a655f);\n  background: var(--interactive-hover, #0a655f);\n}\n.expenses-period {\n  margin-top: 26px;\n}\n.expenses-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  margin-top: 26px;\n}\n.expenses-summary article {\n  min-height: 154px;\n  padding: 24px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n}\n.expenses-summary h2 {\n  margin: 0 0 24px;\n  font-size: 18px;\n  line-height: 25px;\n  font-weight: 500;\n}\n.expenses-summary strong {\n  display: block;\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 22px;\n  line-height: 27px;\n}\n.expenses-summary p {\n  margin: 8px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n.expenses-tabs {\n  display: flex;\n  margin-top: 26px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expenses-tabs button {\n  padding: 10px 16px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n.expenses-tabs button:hover {\n  color: var(--text-secondary, #506360);\n  background: transparent;\n  box-shadow: none;\n}\n.expenses-tabs button.is-active {\n  border-bottom-color: var(--interactive-default, #0f766e);\n  color: var(--interactive-default, #0f766e);\n}\n.expenses-filters {\n  display: grid;\n  grid-template-columns: minmax(0, 320px) minmax(0, 1fr);\n  align-items: center;\n  column-gap: 12px;\n  row-gap: 10px;\n  padding: 12px 0 24px;\n}\n.expenses-search {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n}\n.expenses-search > svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  color: var(--text-secondary, #506360);\n}\n.expenses-search input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font-size: 13px;\n}\n.expenses-search:hover {\n  border-color: var(--border-strong, #8b9996);\n}\n.expenses-search:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.expenses-filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n.expenses-filter {\n  flex: 0 1 auto;\n  width: max-content;\n  max-width: 100%;\n}\n.expenses-filter-row .quotation-figma-dropdown-trigger {\n  height: auto;\n  min-height: 44px;\n  padding: var(--space-3, 12px);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font: 500 13px/18px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expenses-filter-row .quotation-figma-dropdown-trigger > span {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.expenses-filter-row .quotation-figma-dropdown-trigger:hover {\n  border-color: var(--border-strong, #8b9996);\n}\n.expenses-filter-row .quotation-figma-dropdown.is-open .quotation-figma-dropdown-trigger,\n.expenses-filter-row .quotation-figma-dropdown-trigger:focus-visible {\n  padding: 11px;\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.expenses-filter-row .quotation-figma-dropdown-menu {\n  max-height: 224px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n.expenses-clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.expenses-clear:hover {\n  background: var(--surface-secondary, #f4f7f7);\n  border-color: var(--border-default, #cdd6d4);\n}\n.expenses-filters > p {\n  grid-column: 1 / -1;\n  margin-top: 0;\n}\n.expenses-register {\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  overflow: visible;\n}\n.expenses-register__heading,\n.expenses-pagination {\n  min-height: 50px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n}\n.expenses-register__heading span,\n.expenses-pagination {\n  color: var(--text-secondary, #506360);\n}\n.expenses-table-wrap {\n  overflow-x: auto;\n}\n.expenses-register table {\n  border-collapse: collapse;\n  width: 100%;\n  min-width: 1120px;\n}\n.expenses-register th,\n.expenses-register td {\n  padding: 14px 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  font-size: 13px;\n}\n.expenses-register th {\n  height: 64px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font-weight: 500;\n}\n.expenses-register td {\n  height: 76px;\n}\n.expenses-money {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n}\n.expenses-status {\n  display: inline-flex;\n  padding: 3px 7px;\n  border-radius: 999px;\n  font-size: 12px;\n}\n.expenses-status.is-attached {\n  background: var(--surface-tertiary, #e8edec);\n  color: var(--text-secondary, #506360);\n}\n.expenses-status.is-missing {\n  background: var(--warning-soft, #fef8ec);\n  color: var(--warning-text, #7d4412);\n}\n.expenses-receipt-state {\n  display: inline-grid;\n  justify-items: start;\n  gap: 4px;\n}\n.expenses-receipt-state button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #0f766e);\n  font: 500 12px/16px var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.expenses-receipt-state button:hover {\n  color: var(--interactive-hover, #0a655f);\n  text-decoration: underline;\n}\n.expenses-actions-cell {\n  position: relative;\n}\n.expenses-actions-cell > button {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.expenses-menu {\n  position: absolute;\n  right: 16px;\n  top: 52px;\n  z-index: 5;\n  min-width: 112px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 8px 24px rgba(14, 26, 32, 0.12);\n}\n.expenses-menu button {\n  width: 100%;\n  padding: 8px;\n  border: 0;\n  border-radius: 6px;\n  text-align: left;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.expenses-menu button:hover {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.expenses-empty {\n  padding: 40px;\n  text-align: center;\n  color: var(--text-secondary, #506360);\n}\n.expenses-pagination > div {\n  display: flex;\n  gap: 8px;\n}\n.expenses-pagination button {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.expenses-pagination button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.expenses-disclaimer {\n  margin-top: 22px;\n}\n/* Match quotation and invoice register typography without changing layout. */\n.expenses-hero h1 {\n  font-weight: 600;\n}\n.expenses-hero p {\n  font-size: 14px;\n  line-height: 22px;\n}\n.expenses-page .expenses-button,\n.expenses-page .expenses-tabs button,\n.expenses-page .expenses-clear {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.expenses-search input {\n  font-size: 14px;\n  line-height: 20px;\n}\n.expenses-summary strong {\n  font-size: 24px;\n  line-height: 29px;\n}\n.expenses-register__heading strong {\n  font-weight: 500;\n}\n.expenses-register td {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n}\n.expenses-register td.expenses-money {\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 500;\n}\n.expenses-status {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n}\n.expenses-page .expenses-menu button {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n.expenses-pagination {\n  font-size: 12px;\n  line-height: 17px;\n}\n@media (max-width: 900px) {\n  .expenses-summary {\n    grid-template-columns: 1fr;\n  }\n  .expenses-summary article {\n    min-height: auto;\n  }\n}\n@media (max-width: 600px) {\n  .expenses-filters {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 12px;\n  }\n  .expenses-hero {\n    display: block;\n  }\n  .expenses-hero h1 {\n    font-size: 28px;\n  }\n  .expenses-hero__actions {\n    margin-top: 20px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n  .expenses-button--primary {\n    grid-column: 1/-1;\n    justify-content: center;\n  }\n  .expenses-summary {\n    gap: 12px;\n    margin-top: 20px;\n  }\n  .expenses-tabs {\n    overflow-x: auto;\n  }\n  .expenses-tabs button {\n    white-space: nowrap;\n  }\n  .expenses-filter-row {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n  .expenses-filter {\n    width: 100%;\n  }\n  .expenses-clear {\n    justify-self: start;\n  }\n  .expenses-register {\n    border-radius: 10px;\n  }\n  .expenses-register__heading span {\n    display: none;\n  }\n  .expenses-table-wrap {\n    overflow: visible;\n  }\n  .expenses-register table {\n    min-width: 0;\n  }\n  .expenses-register thead {\n    display: none;\n  }\n  .expenses-register tbody,\n  .expenses-register tr,\n  .expenses-register td {\n    display: block;\n  }\n  .expenses-register tr {\n    position: relative;\n    padding: 16px;\n    border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  }\n  .expenses-register td {\n    height: auto;\n    min-height: 34px;\n    padding: 6px 44px 6px 112px;\n    border: 0;\n  }\n  .expenses-register td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 16px;\n    color: var(--text-secondary, #506360);\n  }\n  .expenses-register .expenses-actions-cell {\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    padding: 0;\n  }\n  .expenses-register .expenses-actions-cell::before {\n    display: none;\n  }\n  .expenses-menu {\n    right: 0;\n    top: 34px;\n  }\n  .expenses-pagination {\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 16px;\n  }\n  .expenses-pagination span {\n    max-width: 190px;\n  }\n}\n.expenses-loading-row td {\n  height: 76px;\n}\n.expenses-loading-row .app-skeleton {\n  margin-block: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
